import * as axiosService from "../axiosRequests";
import { IChase } from "../../types/IChase";
import { Meta } from "../../types/Meta";
import { endpoint } from "../../utils/endpoint";

export interface IChaseIndexFilters {
  aasmState?: string;
  order?: string;
  page?: number;
  search?: string;
}

export interface IChaseIndexParams {
  aasm_state?: string;
  order?: string;
  page?: number;
  search?: string;
}

export interface IChaseIndexResponse {
  data: IChase[];
  meta: Meta;
}

export const CAMPAIGN_CHASES_ENDPOINT = (campaignId: string | number): string => endpoint(`app/v1.0/campaigns/${campaignId}/chases`);

export const getChases = async (
  campaignId: string | number,
  filters: IChaseIndexFilters,
): Promise<IChaseIndexResponse> => {
  const params: IChaseIndexParams = {
    aasm_state: filters.aasmState,
    order: filters.order,
    page: filters.page,
    search: filters.search,
  };

  const response = await axiosService.axiosGet(
    CAMPAIGN_CHASES_ENDPOINT(campaignId),
    params,
  );

  return response.data;
};

export default {
  getChases,
};
